import { ReactNode, useMemo } from 'react';
import enUS from 'antd/es/locale/en_US';
import esES from 'antd/es/locale/es_ES';

import {
    Col,
    ConfigProvider,
    DatePicker,
    Input,
    Row,
    Select,
} from 'antd';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { ESmallFleetOrderStatus } from '../../../enums/small-fleet-orders.enum';
import { SearchParamValue } from '../../../interfaces/paginate.interface';
import { getSmallFleetStatusesFromArray, getStatusArrayBySmallFleetStatuses } from '../utils/requests.util';

interface Props {
    loading: boolean;
    handleSearchParam: (key: string, value: SearchParamValue) => void;
    refreshData: () => void;
    extra?: ReactNode;
}

const { RangePicker }: any = DatePicker;
const { Search }: any = Input;

const Filters = ({
    loading,
    handleSearchParam,
    refreshData,
    extra,
}: Props) => {
    const { t, i18n } = useTranslation('bookings', { keyPrefix: 'FILTERS' });
    const { t: ts } = useTranslation('small-fleet-orders');
    const [searchParams] = useSearchParams();

    const selectedStatuses = useMemo(() => {
        const statusParam = searchParams.get('status');
        if (!statusParam) return [];

        try {
            return getSmallFleetStatusesFromArray(JSON.parse(statusParam));
        } catch {
            return [];
        }
    }, [searchParams]);

    return (
        <Row className="home__filters" gutter={[16, 16]} justify="start" align="top">
            <Col className="home__filters--col-search">
                <Search
                    style={{ width: 300 }}
                    allowClear
                    placeholder={t('SEARCH_REQUESTS')}
                    disabled={loading}
                    onSearch={(value: string) => handleSearchParam('search', value)}
                    enterButton
                />
            </Col>
            <Col className="home__filters--col-numeric">
                <ConfigProvider locale={i18n.language === 'en' ? enUS : esES}>
                    <RangePicker
                        onChange={(date: any = []) => {
                            if (handleSearchParam) {
                                if (date) {
                                    const [startDate, endDate] = date;
                                    handleSearchParam('startDate', startDate.startOf('day').toISOString());
                                    handleSearchParam('endDate', endDate.endOf('day').toISOString());
                                } else {
                                    handleSearchParam('startDate', null);
                                    handleSearchParam('endDate', null);
                                }
                            }
                        }}
                    />

                </ConfigProvider>
            </Col>
            <Col>
                <Select
                    mode="multiple"
                    style={{ width: 200 }}
                    allowClear
                    placeholder={t('STATUS')}
                    disabled={loading}
                    value={selectedStatuses}
                    maxTagCount="responsive"
                    dropdownStyle={{ maxHeight: 300, overflow: 'auto' }}
                    onChange={(values: ESmallFleetOrderStatus[]) => {
                        handleSearchParam('status', values?.length ? getStatusArrayBySmallFleetStatuses(values) : null);
                    }}
                >
                    <Select.Option value={ESmallFleetOrderStatus.PENDING}>
                        {ts('PENDING')}
                    </Select.Option>
                    <Select.Option value={ESmallFleetOrderStatus.ASSIGNED}>
                        {ts('ASSIGNED')}
                    </Select.Option>
                    <Select.Option value={ESmallFleetOrderStatus.LOST}>
                        {ts('LOST')}
                    </Select.Option>
                </Select>
            </Col>
            {/* <Col className="home__filters--col-search">
                <Input
                    allowClear
                    placeholder={t('SEARCH_BY_NUMERIC_ID')}
                    onChange={(e: any) => handleSearchParam('bookingNumericId', e.target.value)}
                    value={bookingNumericId}
                    disabled={loading}
                />
            </Col>
            */}
            {extra && (
                <Col flex="auto" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    {extra}
                </Col>
            )}
        </Row>
    );
};

export { Filters };
